import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import NcImage from "shared/NcImage/NcImage";
import axios from 'axios';

const BlogSingle = () => {
  const [content, setContent] = useState<string>('');
  const [featuredImage, setFeaturedImage] = useState<string>('');
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const postId = queryParams.get('id');

  useEffect(() => {
    const fetchContent = async () => {
      if (postId) {
        try {
          const response = await fetch(`https://blog.paradiseliving.homes/wp-json/wp/v2/posts/${postId}`);
          const data = await response.json();
          const featuredImageResponse = await axios.get(`https://blog.paradiseliving.homes/wp-json/wp/v2/media/${data.featured_media}`);
          setFeaturedImage(featuredImageResponse.data.guid.rendered);
          // console.log(data);
          console.log(featuredImageResponse);
          setContent(data.content.rendered);
        } catch (error) {
          console.error('Error fetching post content:', error);
        }
      }
    };
    fetchContent();
  }, [postId]);

  const renderContent = () => {
    return (
      <div
        id="single-entry-content"
        className="prose dark:prose-invert prose-sm !max-w-screen-md sm:prose lg:prose-lg mx-auto dark:prose-dark"
        dangerouslySetInnerHTML={{ __html: content }}
      ></div>
    );
  };




  return (
    <div className="nc-PageSingle pt-2  ">
     
      <NcImage
        className="w-full rounded-xl"
        containerClassName="container my-10 sm:my-12 "
        src={featuredImage}
      />

      <div className="nc-SingleContent container space-y-10">
        {renderContent()}
        
      </div>
      
    </div>
  );
};

export default BlogSingle;
